import { toasterApi } from '../../toast/ToastProvider';

export const notifyInventoryFailure = ({
  title,
  error,
  fallbackDescription,
}: {
  title: string;
  error: unknown;
  fallbackDescription?: string;
}): void => {
  console.error(error instanceof Error ? error : new Error(String(error)));
  toasterApi.error({
    title,
    description: error instanceof Error ? error.message : fallbackDescription,
  });
};
